import { render, staticRenderFns } from "./ImportCsvToDb.vue?vue&type=template&id=1be0e07e&scoped=true&"
import script from "./ImportCsvToDb.vue?vue&type=script&lang=js&"
export * from "./ImportCsvToDb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0e07e",
  null
  
)

export default component.exports